module.exports = __webpack_public_path__ + "img/mp-table-resize.cbd84331.jpg";